import * as React from 'react'
import { NextSeo } from 'next-seo'

import * as entity from '@boutique/entities'
import * as url from '@boutique/url'
import { SITE_NAME, SITE_URL } from '@boutique/config'

import { useProductListing } from './hooks/useProductListing'

export function Seo({ htmlTitle, seoText }: { htmlTitle: string; seoText: string }): React.ReactElement | null {
  const { query, response } = useProductListing()

  if (response.data === undefined) {
    return null
  }

  const realUrl = SITE_URL + url.products({ title: '', query }).path
  const canonical = getCanonicalUrl(query)

  const hasLessThanFiveProducts = response.data.nbHits < 5
  const isIgnoredIndexing = realUrl !== canonical

  const noIndex = hasLessThanFiveProducts || isIgnoredIndexing || (!isIgnoredIndexing && Boolean(query.page))

  const noFollow = hasLessThanFiveProducts || isIgnoredIndexing

  return (
    <NextSeo
      title={`${htmlTitle ? htmlTitle : 'Les produits'} | ${SITE_NAME}`}
      description={seoText ? seoText : 'Découvrez tous les produits'}
      canonical={canonical}
      nofollow={noFollow}
      noindex={noIndex}
      openGraph={{
        title: `${htmlTitle ? htmlTitle : 'Les produits'} | ${SITE_NAME}`,
        description: `${seoText ? seoText : 'Découvrez tous les produits'}`,
        url: canonical,
        images: [
          {
            alt: 'Bien ou Bien, le magasin où acheter des biens tout simplement bien',
            url: SITE_URL + '/assets/images/Ulule_Boutique.png',
          },
        ],
      }}
      robotsProps={{
        maxImagePreview: noIndex && noFollow ? 'none' : 'large',
      }}
    />
  )
}

function getCanonicalUrl(query: entity.search.product.Query): string {
  const canonicalFilter =
    query.facetFilters?.category !== undefined
      ? 'category'
      : query.facetFilters?.brands
      ? 'brands'
      : query.facetFilters?.environmentalPillars
      ? 'environmentalPillars'
      : query.facetFilters?.socialPillars
      ? 'socialPillars'
      : undefined

  return (
    SITE_URL +
    url.products({
      title: '',
      query: {
        ...query,
        facetFilters: canonicalFilter ? { [canonicalFilter]: query.facetFilters?.[canonicalFilter] } : undefined,
        hierarchy: query.hierarchy,
        fullTextSearch: undefined,
        searchableTag: undefined,
        sort: undefined,
      },
    }).path
  )
}
